export type AudioEventTarget = {
  addEventListener: (event: string, listener: EventListener) => void;
  removeEventListener: (event: string, listener: EventListener) => void;
};

export type AudioEventHandlers = {
  timeupdate: EventListener;
  play: EventListener;
  pause: EventListener;
  ended: EventListener;
  error: EventListener;
  loadedmetadata: EventListener;
};

export const attachAudioEvents = (
  target: AudioEventTarget,
  handlers: AudioEventHandlers
): (() => void) => {
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "timeupdate",
    handlers.timeupdate
  );
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "play",
    handlers.play
  );
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "pause",
    handlers.pause
  );
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "ended",
    handlers.ended
  );
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "error",
    handlers.error
  );
  /* action-id: lifecycle.audio.playback */ target.addEventListener(
    "loadedmetadata",
    handlers.loadedmetadata
  );
  return () => {
    target.removeEventListener("timeupdate", handlers.timeupdate);
    target.removeEventListener("play", handlers.play);
    target.removeEventListener("pause", handlers.pause);
    target.removeEventListener("ended", handlers.ended);
    target.removeEventListener("error", handlers.error);
    target.removeEventListener("loadedmetadata", handlers.loadedmetadata);
  };
};
